// The app icon: must stay identical to web/public/favicon.svg.
export const BallotLogo = ({size = 30}: {size?: number}) => (
    <svg
        className="bt-logo"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        aria-hidden="true"
        focusable="false"
    >
        <rect width="64" height="64" rx="14" fill="#d23b38" />
        <rect
            x="8"
            y="38"
            width="48"
            height="20"
            rx="4"
            fill="#ffd23f"
            stroke="#1d1a16"
            strokeWidth="3"
        />
        <rect x="18" y="44" width="28" height="4" rx="2" fill="#1d1a16" />
        <g transform="rotate(-10 32 25)">
            <rect
                x="19"
                y="7"
                width="26"
                height="34"
                rx="3"
                fill="#fffdf7"
                stroke="#1d1a16"
                strokeWidth="3"
            />
            <g transform="translate(21.1 17.6) scale(0.85)">
                <path
                    d="M8.55 5.44H17.11V0.45H13.02C10.56 0.45 8.55 0.45 8.55 3.07V5.44Z"
                    fill="#285C4D"
                />
                <path
                    d="M17.11 10.43H8.55V15.42H12.64C15.11 15.42 17.11 15.42 17.11 12.81V10.43Z"
                    fill="#285C4D"
                />
                <path
                    d="M17.11 0.45H0V10.43H8.58V5.44L8.58 5.23C8.57 2.59 10.7 0.45 13.34 0.45H17.11Z"
                    fill="#00AF66"
                />
                <path
                    d="M8.55 15.42H25.67V5.44H17.08V10.43L17.08 10.64C17.1 13.28 14.97 15.42 12.33 15.42H8.55Z"
                    fill="#00AF66"
                />
            </g>
        </g>
    </svg>
);
